import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import React from "react";
import { useParams } from "react-router";
import styles from "./search-results-list-view-item.module.css";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import { SearchResultsListViewItemChildren } from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsListViewItem/SearchResultsListViewItemChildren";

interface SearchResultsListViewItemProps {
  item: Item;
  itemCardRenderType?: SearchItemCardRenderType;
  handleItemCardClick?: (product: Item) => void;
}

export const SearchResultsListViewItem = ({
  item,
  handleItemCardClick,
  itemCardRenderType = SearchItemCardRenderType.link,
}: SearchResultsListViewItemProps) => {
  const { type } = useParams<{ type: string }>();
  const isGlobalSearch = type === "global";

  let navigationUrl;
  if (isGlobalSearch) {
    navigationUrl = `/product/${item.type}${item.no}`;
  } else {
    navigationUrl = `/task/new/${type}`;
  }

  const isLocalCombination = item.type === "SCI";

  return itemCardRenderType === "button" ? (
    <div
      className={styles["list-item-root"] || ""}
      onClick={() => {
        handleItemCardClick?.(item);
      }}
      data-testid="search-results-list-view-item"
      role={"button"}
    >
      <SearchResultsListViewItemChildren
        item={item}
        isLocalCombination={isLocalCombination}
      />
    </div>
  ) : (
    <FixaLink
      to={navigationUrl}
      state={{
        fromSearch: true,
        product: {
          supplierNumber: "",
          product: item.no,
          type: "ART",
        },
      }}
      className={styles["list-item-root"] || ""}
      data-testid="search-results-list-view-item"
    >
      <SearchResultsListViewItemChildren
        item={item}
        isLocalCombination={isLocalCombination}
      />
    </FixaLink>
  );
};
